import React from "react";
//#region types
import { CashReconciliationStateFlowProps } from "models/propTypes/cashReconciliationPropTypes";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
//#endregion
//#region components
import { LinearStateFlowContainer, useMountedState } from "components/common";
import { useCashReconciliationService } from "serviceHooks";
//#endregion

const CashReconciliationStateFlow: React.FC<CashReconciliationStateFlowProps> = (props) => {
  const cashReconciliationService = useCashReconciliationService();
  const { getMounted } = useMountedState();
  const { id } = props;

  const [states, setStates] = React.useState<ApiModels.EntityStateLog[]>();

  React.useEffect(() => {
    cashReconciliationService.getStateLogs(id).then((items) => {
      if (getMounted()) {
        setStates(items);
      }
    });
  }, [id]);

  return (
    <>{states && <LinearStateFlowContainer steps={states} translationKey={"CashReconciliation.StateFlowState"} />}</>
  );
};

export default CashReconciliationStateFlow;
